<template>
  <div class="flex space-x-6 items-center" :class="{ 'text-orange': isActive }">
    <h3 class="flex-auto uppercase font-bold">
      {{ title }}
    </h3>

    <button
      type="button"
      class="text-sm text-black capitalize border-0 border-b-2 border-solid border-orange hover:border-transparent hoverable-static"
      @click="$emit('click')"
    >
      <span class="hoverable-highlight">{{ details }}</span>
    </button>

    <div v-if="isLocked">
      <div class="cookie-toggle flex content-center justify-center rounded-full bg-green p-1 w-10">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path
            d="M10.5 5.833V3.5a3.5 3.5 0 00-7 0v2.333H1.75V14h10.5V5.833H10.5zm-5.833 0V3.5A2.336 2.336 0 017 1.167 2.336 2.336 0 019.333 3.5v2.333H4.667z"
            fill="#fff"
          />
        </svg>
      </div>
    </div>
    <label v-else>
      <input
        type="checkbox"
        class="hidden cookie-toggle-input"
        :checked="value"
        @change="$emit('toggle')"
      />

      <div class="cookie-toggle flex content-start rounded-full bg-gray-300 p-1 w-10">
        <div class="dot bg-white w-4 h-4 rounded-full cookie-toggle-dot"></div>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    isLocked: { type: Boolean, default: false },
    isActive: Boolean,
    value: Boolean,
    title: String,
    details: String
  }
};
</script>

<style scoped>
.cookie-toggle-input:checked + .cookie-toggle {
  @apply bg-green;
  justify-content: flex-end;
}
</style>
